import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {onSocketStatus} from '../../api';

export default function ConnectionToast() {
    const {t} = useTranslation();
    const [status, setStatus] = useState('connected');
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        onSocketStatus(s => setStatus(s));
    }, []);

    // Show as soon as we're not connected; start slide-out on reconnect.
    useEffect(() => {
        if (status !== 'connected') {
            setVisible(true);
        } else {
            // Brief delay so the slide-out animation plays before unmounting.
            const timer = setTimeout(() => setVisible(false), 600);
            return () => clearTimeout(timer);
        }
    }, [status]);

    const COLORS = {
        disconnected: '#b94040',
        reconnecting: '#7a6a20',
    };

    const shown = visible && status !== 'connected';
    const slideIn = visible && status !== 'connected';

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: '50%',
            transform: `translateX(-50%) translateY(${slideIn ? '0' : '120%'})`,
            transition: 'transform 0.35s cubic-bezier(0.34, 1.2, 0.64, 1)',
            background: COLORS[status] || '#555',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '10px 10px 0 0',
            fontSize: 14,
            fontFamily: 'sans-serif',
            boxShadow: '0 -2px 16px rgba(0,0,0,0.4)',
            zIndex: 9999,
            display: visible ? 'flex' : 'none',
            alignItems: 'center',
            gap: 10,
            whiteSpace: 'nowrap',
        }}>
            <span style={{fontSize: 18}}>{status === 'reconnecting' ? '🔄' : '⚠️'}</span>
            {t('connectionToast.' + status)}
        </div>
    );
}
